import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PagamentoDespesaListarRoutingModule } from "./pagamento-despesa-listar-routing.module";
import { PagamentoDespesaListarComponent } from "./pagamento-despesa-listar.component";

import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { RippleModule } from "primeng/ripple";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { SplitButtonModule } from 'primeng/splitbutton';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ConfirmationService } from "primeng/api";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";
import { MessagesModule } from "primeng/messages";
import { RadioButtonModule } from "primeng/radiobutton";
import { ProgressSpinnerModule } from "primeng/progressspinner";





@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        InputTextareaModule,
        FileUploadModule,
        RippleModule,        
        ChipModule,
        MessagesModule,
        TableModule,
        EditorModule,
        PagamentoDespesaListarRoutingModule,    
        HttpClientModule,        
        TooltipModule,
        DividerModule,
        SplitButtonModule,
        ConfirmDialogModule,
        DropdownModule,
        CalendarModule,
        RadioButtonModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [PagamentoDespesaListarComponent]
})
export class PagamentoDespesaListarModule { }
